import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import whatInput from 'what-input'

const CheckBox = ({ label, className, uid, ...props }) => {
  const [hasFocus, setFocus] = useState(false)
  const showFocusStyle = hasFocus && whatInput.ask() !== 'mouse'

  return (
    <label
      className={classNames('flex', 'items-center', className)}
      data-uid={uid}
    >
      <span
        className={classNames(
          'w-24',
          'h-24',
          'border-2',
          'border-green',
          {
            'border-blue': showFocusStyle,
          },
          'flex',
          'items-center',
          'justify-center',
          'mr-8',
        )}
      >
        <span
          className={classNames('transition', {
            'bg-green': props.checked,
            'bg-white': !props.checked,
          })}
          style={{ width: 18, height: 18 }}
        />
      </span>
      <input
        type="radio"
        className="sr-only"
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        {...props}
      />
      <span className="type-17" htmlFor={props.id}>
        {label}
      </span>
    </label>
  )
}

CheckBox.propTypes = {
  label: PropTypes.node,
  id: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  uid: PropTypes.string,
}

export default CheckBox
